import * as React from "react";
import type { FormulaNameStr } from "../../taskpane";
import { formulaByColor } from "../../taskpane";
import InsertToCell from "../Actions/InsertToCell";
import type { ResultObject } from "../Forms/MyForm";
import MyForm from "../Forms/MyForm";

const runFunction = async (values: { [label: string]: string | FormulaNameStr}): Promise<ResultObject> => {
  const cellRangeAddress = values.cellRange;
  const colorAddress = values.colorAddress;
  const formulaName = values.formulaName as FormulaNameStr;
  const result = await formulaByColor(cellRangeAddress, colorAddress, formulaName);
  return {
    intent: "success",
    title: "Function Executed",
    message: `The result of ${formulaName} is ${result}. Click the button below to insert the result into the active cell.`,
    result: result
  };
}

const ByColorForm: React.FC = () => {
  // const [page, setPage] = React.useState<JSX.Element>(
  //   <MyForm/>
  //   />
  // );

  return (
    <>
          <MyForm
            title="Aggregate by color"
            description="Apply an aggregate formula on all cells in a cell range that match the color of another cell."
            onSubmit={runFunction}
            inputs={[
              {
                labelDescription: "Cell range to aggregate",
                label: "cellRange",
                isRequired: true,
                validatorFunction: (value: string) => {
                  if (value.length < 5) {
                    return {
                      state: "error",
                      message: "Must be at least 5 characters",
                    };
                  }
                  return {
                    state: "success",
                    message: "Looks good!",
                }
              },
              isButtonHelper: true,
              buttonHelperType: "rangePicker"
              },
              {
                labelDescription: "Cell location of color to aggregate by",
                label: "colorAddress",
                isRequired: true,
                validatorFunction: (value: string) => {
                  if (value.length < 2) {
                    return {
                      state: "error",
                      message: "Must be at least 2 characters",
                    };
                  }
                  return {
                    state: "success",
                    message: "Looks good!",
                }
              },
              isButtonHelper: true,
              buttonHelperType: "rangePicker"
              },
              {
                labelDescription: "Formula to apply to colored cells",
                label: "formulaName",
                isRequired: true,
                options: ["SUM", "AVERAGE", "MAX", "MIN"],
                validatorFunction: (value: string) => {
                  if (!["SUM", "AVERAGE", "MAX", "MIN"].includes(value)) {
                    return {
                      state: "error",
                      message: "Must be one of: SUM, AVERAGE, MAX, MIN",
                    };
                  }
                  return {
                    state: "success",
                    message: "Looks good!",
                }
              }}
            ]}
            actionElement={InsertToCell}
            startIntentTitle="Info"
            startIntentMessage="After filling in the form data, click the Submit button to run the formula."
          />
    </>
  );
};
export default ByColorForm;
